import { mergeStyles, Tag } from '@cian/components';
import * as React from 'react';

import { UndergroundIcon } from '../../../../../common/components/underground_icon';
import { IGeoUndergroundTag } from '../../../../state/tags/definitions/geo/underground';
import { TagNew } from '../../TagNew';

const style = require('./underground.css');

export interface IGeoUndergroundTagItemProps {
  tag: IGeoUndergroundTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const GeoUndergroundTagItem = (props: IGeoUndergroundTagItemProps) => {
  if (props.withNewTag) {
    return (
      <TagNew onDeleteClick={props.onDeleteClick}>
        {props.tag.color && (
          <span className={style['icon-wrapper']}>
            <UndergroundIcon color={props.tag.color} />
          </span>
        )}
        {props.tag.text}
        {props.tag.releaseYear && <> &#183; {props.tag.releaseYear}</>}
      </TagNew>
    );
  }

  return (
    <Tag
      onDeleteClick={props.onDeleteClick}
      tagStyles={
        mergeStyles(
          style['underground'],
          props.tag.color && style['underground--withIcon'],
          // tslint:disable-next-line: no-any
        ) as any
      }
    >
      {props.tag.color && <UndergroundIcon color={props.tag.color} />}
      {props.tag.text}
      {props.tag.releaseYear && <> &#183; {props.tag.releaseYear}</>}
    </Tag>
  );
};
